export const numberToCurrency = (value) => {
  return Number(value).toLocaleString() + "円";
};
export const numberToPercentage = (value) => {
  return value.toLocaleString() + "%";
};
export const numberWithDelimiter = (value) => {
  return Number(value).toLocaleString();
};
export const ymdDateFormat = (value, fmt = null) => {
  if (fmt) {
    return (
      value.toString().substr(0, 4) +
      fmt +
      (value.toString().substr(4, 2)
        ? String(Number(value.toString().substr(4, 2)))
        : "") +
      fmt +
      (value.toString().substr(6, 2)
        ? String(Number(value.toString().substr(6, 2)))
        : "")
    );
  }
  return (
    value.toString().substr(0, 4) +
    "年" +
    (value.toString().substr(4, 2)
      ? String(Number(value.toString().substr(4, 2)))
      : "") +
    "月" +
    (value.toString().substr(6, 2)
      ? String(Number(value.toString().substr(6, 2)))
      : "") +
    "日"
  );
};
